const  printerArr= [
    { label: "全部", value: 0 },
    { label: "提交给快递员", value: 1 },
    // { label: "本人打印", value: 2 },
  ]
const createrArr=[
    { label: "全部", value: 0 },
  ]
import team from "@/api/team";
import { mapGetters } from "vuex";
export default {
    data () {
        return {
            printerArr: [],
            createrArr:[],
        }
    },
    mounted() {
        this.getTeamInfo()
    },
    watch: {
      getTeammodel:{
        handler(val) {
          this.getTeamInfo()
          this.loadData()
        },
        immediate:false
      }
    },
    computed: {
      ...mapGetters(["getTeammodel"]),
    },
    methods: { 
        getTeamInfo(){
            if(this.getTeammodel==1){
              this.printerArr = printerArr.concat({ label: "本人打印", value: 2 })
              return
            }else{
              team.getTeamInfo(this).then((res) => {
               if (res.success) {
                //  debugger
                let result = res.data.team_members
                if(Array.isArray(result)){
                  let newArr=result.map(item => {
                    return {
                      label:item['mem_account_name'], 
                      value:item['mem_account_id'],
                    }
                  })
                  this.printerArr = printerArr.concat(newArr)
                  this.createrArr = createrArr.concat(newArr)
                }else{
                  this.printerArr = printerArr.concat({ label: "本人打印", value: 2 })
                  this.createrArr = createrArr.concat(newArr)
                }
               }
             });
            }
          },
    }
}

